import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const propTypes = exact({
  render: PropTypes.func.isRequired,
});


const HorizontalCenterLayout = (props) => {
  const { render } = props;
  return (
    <div style={{ margin: '0 auto', width: '50vw' }}>
      {render()}
    </div>
  );
};


HorizontalCenterLayout.propTypes = propTypes;

export default HorizontalCenterLayout;
